export const offset = (el: HTMLElement) => {
	const offset = { top: 0, left: 0 };
	const _deep = 20; // prevents while loop to be infinite
	let numberOfLoops = 0;

	// As long as there is a parent element, add the offset to the total and reset the parent element to the next
	while (el && el instanceof HTMLElement && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop) && numberOfLoops < _deep) {
		offset.left += el.offsetLeft - el.scrollLeft;
		offset.top += el.offsetTop - el.scrollTop;
		el = el.offsetParent as HTMLElement;
		numberOfLoops++;
	}

	return { offsetTop: offset.top, offsetLeft: offset.left };
};
